import React, { useEffect } from "react";
import { NavLink, useParams } from "react-router-dom";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Tooltip from "@material-ui/core/Tooltip";
import DescriptionIcon from "@material-ui/icons/Description";
import useReducerOnChange from "../../hooks/ReducerOnChange";
import * as Glob from "../../Globale";
import * as Dati from "../../Dati";
import { Trad } from "../../components";
import { _MainContent, _PageTitle, _PageWrapper } from "../layout";
import { _Button, _ExposureLimitsListTable, _InfoSection, _InfoTabs } from "../components";
import { _Autocomplete, _DateField, _Select } from "../form";
import useTable from "../hooks/Table";
import {DeleteEmptyParams} from "../helpers/Common";
import InsertDriveFileIcon from "@material-ui/icons/InsertDriveFile";
import teal from "@material-ui/core/colors/teal";

interface IRouteParam {
    ID_Anag: string;
}

export const _ExposureLimitsSearch: React.FC<Glob.IRouteGlobaleProps> = props => {
    const { ID_Anag } = useParams<IRouteParam>();
    const [FormData, setFormData] = useReducerOnChange<Dati.TListaParametri>({
        ID_FideAffidamento: "",
        ID_Utente: "",
        ID_TipoFideAffidamento: "",
        ID_TipoFideAffidamentoEsito: "",
        DataDa: "",
        DataA: "",
        AnagA: ID_Anag,
        ID_AnagA: "",
        ID_AnagDa: ""
    });
    const { Data, Options, IsLoading } = useTable("/api/FideAffidamento/RicercaGenerale", FormData);

    useEffect(() => {
        if (!Glob.AzioneAbilitata("FideAffidamentoController", Glob.Lettura)) {
            location.replace("/ErroreAccesso");
            return;
        }

        props.SetMenu({ ...Glob.GetMenu(), Main: "Home", ID_MenuMain: 10 });
    }, []);

    return (
        <_PageWrapper {...props}>
            <Container component="main" maxWidth="lg">
                <_PageTitle Icon={DescriptionIcon} Title="Affidamenti">
                    {Glob.AzioneAbilitata("FideAffidamentoController", Glob.Scrittura) && (
                        <a href={`/api/FideAffidamento/EsportaEXCEL?sessione=${Glob.GetSessione().Sessione}&parametri=${JSON.stringify(DeleteEmptyParams({ ...FormData }))}`} target="_blank">
                            <Tooltip title="Excel">
                                <IconButton size="small" aria-label="add">
                                    <InsertDriveFileIcon htmlColor={teal[400]} />
                                </IconButton>
                            </Tooltip>
                        </a>
                    )}
                </_PageTitle>
                <_MainContent WithPaper={false}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Card>
                                <CardContent>
                                    <form noValidate autoComplete="off">
                                        <Grid container spacing={4}>
                                            <Grid item xs={12} md={2}>
                                                <TextField
                                                    fullWidth
                                                    id="ID_FideAffidamento"
                                                    label={Trad.Trad("ID")}
                                                    value={FormData.ID_FideAffidamento}
                                                    onChange={e => setFormData({ Type: "OnChangeFromForm", Target: e.currentTarget })}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                <_Autocomplete
                                                    SearchInput
                                                    Value={FormData.ID_TipoFideAffidamento}
                                                    Name="ID_TipoFideAffidamento"
                                                    Label="Tipo"
                                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                                    Url="/api/Tipi/ListaTipi?ID_TipoContesto=FideAffidamento"
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                <_Autocomplete
                                                    Value={FormData.ID_AnagDa}
                                                    Name="ID_AnagDa"
                                                    Label="Da"
                                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                                    Url="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                <_Autocomplete
                                                    Value={FormData.ID_AnagA}
                                                    Name="ID_AnagA"
                                                    Label="A"
                                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                                    Url="/api/Anag/RicercaVeloce?id_TipoAnag=&ricerca="
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                <_Autocomplete
                                                    SearchInput
                                                    Value={FormData.ID_TipoFideAffidamentoEsito}
                                                    Name="ID_TipoFideAffidamentoEsito"
                                                    Label="Esito"
                                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                                    Url="/api/Tipi/ListaTipi?ID_TipoContesto=FideAffidamentoEsito"
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={2}>
                                                <_Autocomplete
                                                    SearchInput
                                                    TranslationsOff
                                                    Value={FormData.ID_Utente}
                                                    Name="ID_Utente"
                                                    Label="Utente sottoscrittore"
                                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                                    Url="/api/Utenti/ListaUtenti"
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                <_DateField
                                                    Value={FormData.DataDa || ""}
                                                    Name="DataDa"
                                                    Label="Scadenza Da"
                                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                <_DateField
                                                    Value={FormData.DataA || ""}
                                                    Name="DataA"
                                                    Label="Scadenza A"
                                                    OnChange={(e, val) => setFormData({ Type: "OnChangeFromValue", Name: e, Value: val })}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid>
                                            <Grid item md={1}>
                                                <_Button
                                                    Attivo={!IsLoading}
                                                    Testo={Trad.Trad("Cerca")}
                                                    OnClick={() => {
                                                        Options.onChangePage(0);
                                                    }}
                                                />
                                            </Grid>
                                        </Grid>
                                    </form>
                                    <_ExposureLimitsListTable Data={Data} IsLoading={IsLoading} Options={Options} />
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                </_MainContent>
            </Container>
        </_PageWrapper>
    );
};



// WEBPACK FOOTER //
// ./src/inar2/pages/ExposureLimitsSearch.tsx